import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { combineValidators, isRequired } from 'revalidate';
import { Button, Form, Header, Segment, Table } from 'semantic-ui-react';

import SelectInput from '../../../app/common/form/SelectInput';
import TextInput from '../../../app/common/form/TextInput';
import {
  formatParameterDisp,
  RESERVATION_STATE,
} from '../../../app/common/util/util';
import { RootStoreContext } from '../../../app/stores/rootStore';

const validate = combineValidators({
  schedule: isRequired({ message: '選択してください' }),
  reservationPerson: isRequired({
    message: '入力してください',
  }),
});

const ReservationList: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    submitting,
    schedules,
    scheduleOptions,
    reservation,
    reservationFilters,
    createReservation,
  } = rootStore.reservationStore;

  const handleFinalFormSubmit = (values: any) => {
    //画面選択項目をセット
    values.qrticketId = reservation?.qrticketId;
    values.reservationDate = formatParameterDisp(
      reservationFilters?.reservationDate!
    );
    createReservation(values);
  };

  return (
    <Segment>
      <Header as='h5' textAlign='center'>
        招待券予約空き状況（残り）
      </Header>
      <Table textAlign='center'>
        <Table.Body>
          {schedules.map((s) => (
            <Table.Row key={s.schedule}>
              <Table.Cell>{s.schedule}</Table.Cell>
              <Table.Cell>
                {s.status === RESERVATION_STATE.Danger
                  ? '×'
                  : s.status === RESERVATION_STATE.Warning
                  ? `△（${s.remains}）`
                  : '〇'}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <FinalForm
        validate={validate}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit}>
            <Field
              name='schedule'
              label='来塔希望時間'
              options={scheduleOptions}
              component={SelectInput}
            />
            <Field
              name='reservationPerson'
              label='お名前（カタカナ）'
              component={TextInput}
            />
            <Button
              loading={submitting}
              disabled={invalid || pristine}
              positive
              fluid
              type='submit'
              content='予約する'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(ReservationList);
